import Box from '@mui/material/Box';
import { useIntl } from 'react-intl';

import { i18n } from './DashboardPage.i18n';
import { useStyles } from './DashboardPage.styles';

export const DashboardPage = () => {
    const intl = useIntl();
    const { classes } = useStyles();

    return (
        <Box className={classes.root} automation-id="dashboard-page">
            <Box className={classes.content}>
                <h1>{intl.formatMessage(i18n.title)}</h1>
            </Box>
        </Box>
    );
};
